export default __webpack_public_path__ + "static/media/Mendes.1513ddf2.png";